import Vue from 'vue';
import VueRouter from 'vue-router';
import LandingPage from '../components/LandingPage';
import Products from '../components/Products';
import MerchantView from '../components/MerchantView';
import SignInWindow from '../components/SignInWindow';
import StoreWishlist from '../components/StoreWishlist';
import HowToSave from '../components/HowToSave';
import Partners from '../components/Partners';
import PrivacyTerms from '../components/PrivacyTerms';

const routes = [
  { name: '', path: '/', component: LandingPage },
  { name: 'home', path: '/index.html', component: LandingPage },
  { name: 'howToSave', path: '/howToSave', component: HowToSave },
  { name: 'partners', path: '/partners', component: Partners },
  { name: 'products', path: '/products', component: Products },
  { name: 'merchantView', path: '/merchantView', component: MerchantView },
  { name: 'signin', path: '/signin', component: SignInWindow },
  { name: 'sharing', path: '/sharing', component: StoreWishlist },
  { name: 'privacyAndTerms', path: '/privacy-and-terms', component: PrivacyTerms },
];

Vue.use(VueRouter); // This makes all the magic hapen and Vue recognizes the router-view and router-link

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
